import styled from 'styled-components'
import { AccordionItemBody } from 'react-accessible-accordion'

export const AccordionIcon = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -2rem;
  border-radius: 50%;
  display: inline-block;
  border: 1px solid;
  width: 4rem;
  height: 4rem;
  line-height: 2rem;

  &:after {
    width: 2.4rem;
    height: 2.4rem;
    content: url(../minus.svg);
    position: absolute;
    left: 0.7rem;
    top: 0.7rem;
  }
`

export const AccordionComponent = styled.div`
  .accordion__title[aria-selected='false'] {
    ${AccordionIcon} {
      &:after {
        content: url(../plus.svg);
      }
    }

    &:hover {
      ${AccordionIcon} {
        &:after {
          content: url(../plus-white.svg);
        }
      }
    }
  }
  .accordion__item {
    margin-bottom: 3.2rem;
    background-color: ${props => props.theme.colors.white};
    padding: 2rem;
    cursor: pointer;
  }
  .accordion__body {
    padding-right: 9rem;
  }
  .accordion__title {
    position: relative;
    padding-right: 5rem;

    &:hover {
      text-decoration: underline;
      color: ${props => props.theme.colors.cobalt};

      ${AccordionIcon} {
        background-color: ${props => props.theme.colors.cobalt};
        color: ${props => props.theme.colors.white};

        &:after {
          content: url(../minus-white.svg);
        }
      }
    }
  }
`
export const AccordionBody = styled(AccordionItemBody)`
  margin-top: 3rem;
`
